import React from "react"
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import classes from "./Settings.module.css"


function AutoEmailsTrainer({ autoEmailsTrainer, handleCheckUpdate, setAutoEmailsTrainer }) {
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            If this is checked, you will be copied on emails sent to the client when you create a client, when you update a clients login, when you send a PAR-Q request, and when you make a schedule update. If you do not wish to be copied on these emails, uncheck this box.
        </Tooltip>
    );


    return (
        <Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
            <Card.Body>
                <h4>My Automated Email Settings</h4>
                <hr class="mt-1" />
                {autoEmailsTrainer && Object.entries(autoEmailsTrainer).map(([name, value]) => {

                    let checked;
                    let dbField;
                    let message = "Auto-email me notification message."
                    let displayName = "";
                    switch (name) {
                        case "workout_complete":
                            dbField = "emailCompletedWorkout"
                            displayName = "Complete Workout Notification"
                            break
                        case "nutrition_complete":
                            dbField = "emailCompletedDiet"
                            displayName = "Completed Nutrition Notification"
                            break
                        case "task_complete":
                            dbField = "emailCompletedTask"
                            displayName = "Completed Task Notification"
                            break
                        case "chat_message":
                            dbField = "emailMessagesToTrainer"
                            displayName = "Messages and Comments to Me"
                            message = "Auto-email me the message"
                            break
                        case "cc_on_emails":
                            dbField = "copyTrainerOnEmail"
                            displayName = "Copy Me on Certain Client Emails"
                            message = "Copy me on the message"
                            break;
                        default:
                            console.log("dbfield auto emails incorrect")
                    }

                    if (value == "1" || value === true) {
                        checked = true
                    } else {
                        checked = false;
                    }
                    if (autoEmailsTrainer) {
                        return (
                            <Row key={name} className="d-flex align-items-center justify-content-center mb-5">
                                <Col >
                                    <div className="d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                                        <span> {displayName} &nbsp;
                                        {name === "cc_on_emails" &&
                                                <OverlayTrigger
                                                    placement="right"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={renderTooltip}
                                                >
                                                    <span className="far fa-question-circle"></span>
                                                </OverlayTrigger>
                                            }</span>
                                    </div>
                                </Col>
                                <Col >
                                    <Form.Group className="mb-0" controlId={"trainer" + name}>
                                        <Form.Check name={name} label={message} checked={checked} type="checkbox" className="custom-control custom-checkbox" onChange={(e) => {
                                            let name = e.target.name
                                            let currCheck = e.target.checked
                                            setAutoEmailsTrainer(prev => ({ ...prev, [name]: currCheck }))
                                            handleCheckUpdate(name, currCheck, "automated_emails", dbField)
                                        }}
                                        >
                                        </Form.Check >

                                    </Form.Group>
                                </Col>
                            </Row>
                        )
                    }
                })}


            </Card.Body>

        </Card>
    )
}

export default AutoEmailsTrainer